import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';

export const DOWNLOAD_RELATORIO_COMPLETO_USUARIOS = 'DOWNLOAD_RELATORIO_COMPLETO_USUARIOS';

export default function downloadRelatorioCompletoUsuarios(idEmpresa) {
  const url = `${URL}/usuarios/empresa/${idEmpresa}/relatorio-completo`;
  
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: DOWNLOAD_RELATORIO_COMPLETO_USUARIOS,
      payload: response
    })
  );
}
